import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const Signup: React.FC = () => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{
                backgroundColor: '#121212',
                color: '#ffffff',
                padding: { xs: 4, md: 10 },
            }}
        >
            <Box sx={{ width: '100%', maxWidth: 600, textAlign: 'left' }}>
                <Typography
                    variant="h3"
                    gutterBottom
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '1.8rem', md: '2.5rem' },
                    }}
                >
                    Be the First to Know More
                </Typography>
                <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                        fontSize: { xs: '1rem', md: '1.25rem' },
                    }}
                >
                    put your mail in our waiting list
                </Typography>
                <Button
                    href="mailto:feedback@moosebit.com"
                    variant="outlined"
                    sx={{
                        mt: 2,
                        paddingX: { xs: 2, md: 3 },
                        paddingY: { xs: 1, md: 1.5 },
                        borderColor: '#1bd45a',
                        color: '#1bd45a',
                        alignSelf: 'flex-start',
                        '&:hover': {
                            backgroundColor: '#1bd45a',
                            color: '#121212',
                        },
                    }}
                >
                    Sign Up
                </Button>
            </Box>
        </Box>
    );
};

export default Signup;
